module.exports = __webpack_public_path__ + "static/media/vibino-feature-blur photo-PIC4.d0adbd8f.jpg";